import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { SheetContent } from "@/components/ui/sheet";
import { Grid3X3, Package, Heart, ChevronRight } from "lucide-react";

const G = "#FFB800";

export default function MobileSideSheet() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get("/categories").then(res => {
      const cats = (res.data || []).filter(c => c.active !== false);
      setCategories(cats);
    }).catch(() => {});
  }, []);

  return (
    <SheetContent side="left" className="w-72 p-0" style={{ background: "#FFF9F0", borderRight: "1px solid rgba(0,0,0,0.08)" }}>
      <div className="px-5 pt-6 pb-4" style={{ borderBottom: "1px solid rgba(0,0,0,0.06)" }}>
        <span className="text-lg font-extrabold tracking-tight" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
          <span style={{ color: G }}>Nirvana</span>
          <span style={{ color: "#1A1A1A" }}>Comfort</span>
        </span>
      </div>
      <nav className="flex flex-col py-2 overflow-y-auto max-h-[calc(100vh-80px)]">
        <Link to="/" className="px-5 py-3 text-base font-semibold transition-colors" style={{ color: "#1A1A1A" }}>Home</Link>
        <Link to="/categories" className="px-5 py-3 text-base font-semibold transition-colors flex items-center gap-2" style={{ color: "#1A1A1A" }}>
          <Grid3X3 className="w-4 h-4" /> All Categories
        </Link>
        <div className="my-1" style={{ borderTop: "1px solid rgba(0,0,0,0.06)" }} />
        <p className="px-5 py-2 text-[10px] font-bold uppercase tracking-widest" style={{ color: G }}>Shop by Category</p>
        {categories.map(c => (
          <Link key={c.id || c.slug} to={`/category/${c.slug}`}
            className="px-5 py-2.5 text-sm flex items-center justify-between transition-colors" style={{ color: "#5a5570" }}>
            <span>{c.name}</span>
            <ChevronRight className="w-3.5 h-3.5 opacity-30" />
          </Link>
        ))}
        <div className="my-1" style={{ borderTop: "1px solid rgba(0,0,0,0.06)" }} />
        <Link to="/track" className="px-5 py-3 flex items-center gap-2.5 text-sm transition-colors" style={{ color: "#5a5570" }}>
          <Package className="w-4 h-4" /> Track Order
        </Link>
        <Link to="/wishlist" className="px-5 py-3 flex items-center gap-2.5 text-sm transition-colors" style={{ color: "#5a5570" }}>
          <Heart className="w-4 h-4" /> Wishlist
        </Link>
        <Link to="/about" className="px-5 py-3 flex items-center gap-2.5 text-sm transition-colors" style={{ color: "#5a5570" }}>
          About Us
        </Link>
        <Link to="/contact" className="px-5 py-3 flex items-center gap-2.5 text-sm transition-colors" style={{ color: "#5a5570" }}>
          Contact Us
        </Link>
      </nav>
    </SheetContent>
  );
}
